import { c as r } from "../../../../index.esm-BeDSGXP5.js";
import { css as n } from "styled-components";
const c = (o) => o.components.animatedIcon.variants, p = {
  wrapper: ({ theme: o, variant: a }) => /* @__PURE__ */ n([
    "margin:auto;",
    " ",
    ""
  ], r({
    size: [
      166,
      null,
      288
    ]
  }), c(o)[a]),
  icon: () => /* @__PURE__ */ n([
    "position:relative;width:100%;padding-bottom:100%;> svg{width:150% !important;height:150% !important;position:absolute;top:-25%;left:-25%;}"
  ]),
  variants: {
    alertIcon: ({ theme: o }) => /* @__PURE__ */ n([
      ".primary path{fill:",
      ";fill:",
      ";}.secondary path{fill:",
      ";}"
    ], o.componentColors.animatedIcon.alertIcon.primary, o.componentColors.animatedIcon.alertIcon.primary, o.componentColors.animatedIcon.alertIcon.secondary),
    bankIcon: ({ theme: o }) => /* @__PURE__ */ n([
      ".primary path{fill:",
      ";}"
    ], o.componentColors.animatedIcon.bankIcon.primary),
    bellIcon: ({ theme: o }) => /* @__PURE__ */ n([
      ".primary path{fill:",
      ";}"
    ], o.componentColors.animatedIcon.bellIcon.primary),
    clipboardIcon: ({ theme: o }) => /* @__PURE__ */ n([
      ".primary path{fill:",
      ";}.secondary path{stroke:",
      ";}"
    ], o.componentColors.animatedIcon.clipboardIcon.primary, o.componentColors.animatedIcon.clipboardIcon.secondary),
    eyeIcon: ({ theme: o }) => /* @__PURE__ */ n([
      ".primary path{fill:",
      ";}"
    ], o.componentColors.animatedIcon.eyeIcon.primary),
    gearsIcon: ({ theme: o }) => /* @__PURE__ */ n([
      ".primary path{fill:",
      ";}.secondary path{stroke:",
      ";}"
    ], o.componentColors.animatedIcon.gearsIcon.primary, o.componentColors.animatedIcon.gearsIcon.secondary),
    heartIcon: ({ theme: o }) => /* @__PURE__ */ n([
      ".primary path{fill:",
      ";}"
    ], o.componentColors.animatedIcon.heartIcon.primary),
    lightningIcon: ({ theme: o }) => /* @__PURE__ */ n([
      ".primary path{fill:",
      ";}"
    ], o.componentColors.animatedIcon.lightningIcon.primary),
    mailIcon: ({ theme: o }) => /* @__PURE__ */ n([
      ".primary path{fill:",
      ";}.secondary path{stroke:",
      ";}"
    ], o.componentColors.animatedIcon.mailIcon.primary, o.componentColors.animatedIcon.mailIcon.secondary),
    nopeIcon: ({ theme: o }) => /* @__PURE__ */ n([
      ".primary path{fill:",
      ";}.secondary path{fill:",
      ";}"
    ], o.componentColors.animatedIcon.nopeIcon.primary, o.componentColors.animatedIcon.nopeIcon.secondary),
    padlockIcon: ({ theme: o }) => /* @__PURE__ */ n([
      ".primary path{fill:",
      ";}"
    ], o.componentColors.animatedIcon.padlockIcon.primary),
    paymentIcon: ({ theme: o }) => /* @__PURE__ */ n([
      ".primary path{fill:",
      ";}.secondary path{stroke:",
      ";}"
    ], o.componentColors.animatedIcon.paymentIcon.primary, o.componentColors.animatedIcon.paymentIcon.secondary),
    pinIcon: ({ theme: o }) => /* @__PURE__ */ n([
      ".primary path{fill:",
      ";}.secondary path{stroke:",
      ";}"
    ], o.componentColors.animatedIcon.pinIcon.primary, o.componentColors.animatedIcon.pinIcon.secondary),
    planeIcon: ({ theme: o }) => /* @__PURE__ */ n([
      ".primary path{fill:",
      ";}"
    ], o.componentColors.animatedIcon.planeIcon.primary),
    stopwatchIcon: ({ theme: o }) => /* @__PURE__ */ n([
      ".primary path{fill:",
      ";}.secondary path{stroke:",
      ";}"
    ], o.componentColors.animatedIcon.stopwatchIcon.primary, o.componentColors.animatedIcon.stopwatchIcon.secondary),
    switchesIcon: ({ theme: o }) => /* @__PURE__ */ n([
      ".primary path{fill:",
      ";}.secondary path{stroke:",
      ";}"
    ], o.componentColors.animatedIcon.switchesIcon.primary, o.componentColors.animatedIcon.switchesIcon.secondary),
    thumbsUpIcon: ({ theme: o }) => /* @__PURE__ */ n([
      ".primary path{fill:",
      ";}"
    ], o.componentColors.animatedIcon.thumbsUpIcon.primary),
    tickIcon: ({ theme: o }) => /* @__PURE__ */ n([
      ".primary path{fill:",
      ";}.secondary path{stroke:",
      ";}"
    ], o.componentColors.animatedIcon.tickIcon.primary, o.componentColors.animatedIcon.tickIcon.secondary)
  }
};
export {
  p as default
};
